export default __webpack_public_path__ + "static/media/QC.3eb5bae0.svg";